module.exports = __webpack_public_path__ + "img/wlwsj.db1030b1.png";